/** 繁體中文. See `en.ts` for what each key is and what it has to fit. */

import type { MessageKey } from "./en";

export const zhHant: Record<MessageKey, string> = {
  metaDescription:
    "免費的即時天氣地圖，瀏覽器內動畫播放：GFS、ECMWF、AIFS 數值預報，雷達與衛星雲圖回放，颱風路徑，三維雷達與探空圖。",
  pageTitleLive: "{variable}預報圖 · {model} {hours}H",
  pageTitleLiveObservation: "{variable}觀測圖 · {model} · 近{hours}小時",
  mapAria: "全球氣溫與降水預報地圖",
  modelSwitchAria: "資料集",
  variableSwitchAria: "氣象變數",
  varTemp: "氣溫",
  varPrecip: "降水",
  varWind: "風場",
  varSolar: "輻射",
  varRadar: "雷達",
  varOrog: "地形",
  varInfrared: "紅外 10.4",
  varShortwave: "短波 3.9",
  varDustRgb: "RGB",
  varDustCf: "DEBRA",
  varZhouye: "ZHOUYE",
  varTrueColor: "彩色",
  varGust: "陣風",
  varCloud: "雲量",
  varCape: "對流能",
  varPwat: "氣柱",
  varPtype: "類型",
  varCin: "抑制",
  varHpbl: "高度",
  varVis: "能見度",
  varDewPoint: "露點",
  varFeelsLike: "體感",
  varOmega: "垂直速度",
  varThetaE: "假相當位溫",
  varCat: "晴空亂流",
  varInflow: "暖濕流",
  varFront: "鋒區",
  varHotspot: "熱點",
  varFfwi: "火險氣象",
  varFwalert: "乾燥大風",
  varSst: "海表",
  varIce: "海冰",
  varWave: "海浪",
  varAod: "總量",
  varPm: "2.5",
  varDustsfc: "沙塵",
  varTsoil: "土溫",
  varSoilw: "土濕",
  varHumidity: "濕度",
  varVapourFlux: "水氣",
  varPressure: "氣壓",
  varHeight: "位勢",
  varPressureField: "氣壓場",
  varUnknownLayer: "資料層",

  glyphTmp2m: "溫",
  glyphPrate: "水",
  glyphWind10m: "風",
  glyphDswrf: "輻",
  glyphCref: "雷",
  glyphIr104: "衛",
  glyphIr039: "短",
  glyphDustrgb: "塵",
  glyphDustcf: "信",
  glyphZhouye: "晝",
  glyphTruecolor: "彩",
  glyphGust: "陣",
  glyphTcdc: "雲",
  glyphCape: "能",
  glyphVis: "視",
  glyphPwat: "柱",
  glyphCin: "抑",
  glyphHpbl: "層",
  glyphPtype: "型",
  glyphDpt2m: "露",
  glyphAptmp2m: "感",
  glyphVvel: "ω",
  glyphThetae: "θ",
  glyphCat: "ε",
  glyphInflow: "暖",
  glyphFront: "鋒",
  glyphHotspot: "熱",
  glyphFfwi: "險",
  glyphFwalert: "警",
  glyphTmpsfc: "海",
  glyphIce: "冰",
  glyphWave: "浪",
  glyphAod: "τ",
  glyphPm: "µ",
  glyphDustsfc: "沙",
  glyphTsoil: "地",
  glyphSoilw: "墒",
  glyphPressure: "壓",
  glyphRh: "濕",
  glyphQflux: "汽",
  tipTemp: "氣溫",
  tipHumidity: "相對濕度",
  tipWind: "風",
  tipPressure: "氣壓與位勢高度",
  tipVapourFlux: "水氣通量",
  tipCloud: "雲量",
  tipOmega: "垂直速度",
  tipThetaE: "假相當位溫",
  tipCat: "晴空亂流",
  tipIce: "海冰",
  tipWave: "海浪",
  tipAod: "氣溶膠光學厚度",
  tipPm: "懸浮微粒",
  tipTsoil: "土壤溫度",
  tipSoilw: "土壤濕度",
  tipSatellite: "衛星影像",
  levelSwitchAria: "層次",
  levelCaption: "層次",
  linesCaption: "等壓線",
  accumCaption: "累計",
  accumRateGloss: "降水率",
  accumTotalGloss: "{window} 累計",
  modelHeading: "資料集",
  linesRemoveTitle: "再按一次關閉等壓線疊加",
  fieldSectionAria: "填充場",
  overlaySectionAria: "疊加層",
  markSectionAria: "標記",
  tipMore: "本次運行的全部圖層",
  varMore: "圖層",
  glyphMore: "+",
  fieldSheetAria: "圖層",
  fieldSheetHeading: "圖層",
  fieldGroupTemperature: "溫度",
  fieldGroupMoisture: "水分",
  fieldGroupSoil: "土壤",
  fieldGroupWind: "風",
  fieldGroupDynamics: "動力",
  fieldGroupRadiation: "輻射與能見度",
  fieldGroupAerosol: "氣溶膠與空氣品質",
  fieldGroupOcean: "海洋",
  fieldGroupHydrology: "河川與洪水",
  fieldGroupSatellite: "衛星",
  fieldGroupOther: "其他",
  fieldGroupImagery: "逐日影像：NASA GIBS",
  gibsTrueColor: "真彩",
  gibsFalseColor: "火情",
  gibsTipTrue: "真彩",
  gibsTipFire: "火情假彩：過火跡地暗紅",
  varParticles: "粒子",
  glyphParticles: "粒",
  varVolume: "三維雲",
  glyphVolume: "體",
  levelAlone: "只看線",
  levelAloneTitle: "只看等壓線：去掉填充場，再按一次恢復",
  creditsTrigger: "資料來源",
  creditsHeading: "資料來源與致謝",
  creditsGfs: "預報資料：GFS 0.25° 與 sflux",
  creditsHrrr: "預報資料：HRRR 3 公里，美國本土",
  creditsGefsAero: "氣溶膠預報：GEFS-Aerosols 0.25°，光學厚度與地面懸浮微粒",
  creditsCmaDust: "沙塵預報：CMA-CW v1.0/DUST（WMO SDS-WAS 亞洲中心）0.15°，亞洲區域，經 WMO WIS2",
  creditsSilam: "空氣品質預報：FMI SILAM v6.1 全球 0.2°，CC BY 4.0",
  creditsCfs: "季節預報：CFSv2，9 個月，6 小時間隔",
  creditsEcmwf: "含經修改的 ECMWF 資料，CC BY 4.0",
  creditsIfsHres: "改編自 ECMWF IFS，由 ECMWF 提供，依 CC BY 4.0 授權；經 Open-Meteo 轉發；IFS HRES 約 9 公里，重新取樣至 0.1°",
  creditsMrms: "雷達觀測：MRMS，美國本土",
  creditsNexrad: "單站雷達：基本反射率與徑向速度，美國",
  creditsJma: "雷達降水：氣象廳臨近預報，日本（重採樣）",
  creditsHimawari: "衛星影像：向日葵 9 號 AHI，日本氣象廳，經 NOAA 開放資料（重投影）",
  creditsGoes: "衛星影像：GOES-19 東、GOES-18 西 ABI，NOAA NESDIS，經 NOAA 開放資料（重投影）",
  creditsMeteosat: "衛星影像：含經修改的 EUMETSAT Meteosat 資料 {year}；Meteosat-12 FCI，整點掃描週期，CC-BY-4.0（重投影）",
  creditsSounding: "探空觀測：GTS TEMP 報文經 WIS2 轉發，各國氣象部門",
  creditsAirport: "機場 METAR 與 TAF：各國氣象部門經 NOAA/NWS 航空氣象中心轉發",
  creditsFirms: "活躍火點：LANCE FIRMS 近即時，VIIRS 375 m 與 MODIS，NASA ESDIS",
  creditsGibs: "逐日影像：MODIS 與 VIIRS 校正反射率，NASA ESDIS",
  creditsRadar: "雷達拼圖",
  creditsBasemap: "底圖：© OpenStreetMap 貢獻者",
  creditsTerrain: "地形暈渲：© Mapterhorn，高程資料來源一覽",
  creditsPeaks: "山峰名稱與海拔：CC0",
  creditsCode: "原始碼：ringsaturn/xue",
  caseTag: "個案",
  caseSummaryAria: "個案摘要",
  runCycle: "模式週期",
  recordSpan: "記錄時段",
  latestObservation: "最新觀測",
  latestNowcast: "最新臨近預報",
  awaitingData: "等待資料",
  validTimeLabel: "目前有效時間",
  observationTimeLabel: "目前觀測時間",
  statsAria: "詳細統計資訊",
  statsCloseAria: "關閉詳細統計資訊",
  bufferedFrames: "快取影格",
  downloadedBytes: "資料量",
  formatLabel: "格式",
  formatZarr: "Zarr",
  preloadProgressAria: "預報資料預先載入進度",
  statDataset: "資料集",
  statGrid: "網格",
  statFrameCache: "影格快取",
  statDecodeTime: "解碼耗時",
  statDecodeRate: "解碼速率",
  statViewport: "視埠取樣",
  statConnection: "網路連線",
  awaitingManifest: "等待資料清單",
  legendPrateAria: "降水強度色階",
  timelineAria: "預報時間控制",
  playAnimation: "播放動畫",
  pauseAnimation: "暫停動畫",
  playbackSpeed: "播放速度",
  exportOpenAria: "匯出動畫",
  exportSheetAria: "匯出動畫",
  exportHeading: "匯出",
  exportFormat: "格式",
  exportSize: "尺寸",
  exportFps: "影格率",
  exportRange: "影格範圍",
  exportFrom: "起",
  exportTo: "迄",
  exportRun: "匯出",
  exportCancel: "取消",
  exportSummary: "{size}，{frames} 格，{seconds} 秒，約 {bytes}",
  exportCapturing: "正在擷取 {done}/{total}",
  exportEncoding: "正在編碼 {percent}%",
  exportFailed: "匯出失敗",
  readingManifest: "正在讀取清單",
  forecastHourAria: "預報時次",
  forecastDaysAria: "逐日預報分段",
  observationDaysAria: "逐日分段",
  mapMenuAria: "地圖選項",
  menuStats: "詳細統計資訊",
  menuCopyDebug: "複製除錯資訊",
  errorTitle: "資料無法顯示",
  retry: "重新讀取",
  langPickerAria: "語言",
  langPickerHeading: "語言",
  themeToggleAria: "切換淺色 / 深色",
  viewGlobeAria: "地球視圖",
  viewTerrainAria: "三維地形",
  viewContoursAria: "地形等高線",
  viewResetNorthAria: "重設為正北",
  viewResetPitchAria: "重設俯仰",
  viewBoxAria: "風暴特寫：框選一塊區域",
  viewSectionAria: "垂直剖面：拖一條線",
  viewDistanceAria: "測距：依次點擊各點，再點最後一點結束",
  viewAreaAria: "測面積：依次點擊各頂點，再點首點或末點結束",
  particlesToggle: "粒子動畫",
  particlesToggleAria: "切換風場粒子動畫",

  dataInterrupted: "資料載入中斷",
  errorHint: "{message}。請確認已執行 make mvp,並透過 make serve 開啟頁面。",
  loadFailed: "載入失敗",
  webglLost: "WebGL 無法使用：請完全結束瀏覽器後重新開啟",
  saveData: "省流量",
  debugCopied: "除錯資訊已複製",
  copyFailed: "複製失敗",
  bundleResident: "資料包已駐留記憶體",
  viewportResident: "目前視野已緩衝完畢",
  streamingOnDemand: "依需求串流載入中",
  receivingBundle: "正在接收預報資料包",
  receivingBundlePercent: "接收資料包 {percent}%",
  readingIndex: "正在讀取資料索引",
  initializingDecoder: "正在初始化解碼器",
  framesReady: "{count} 影格就緒",
  readingData: "正在讀取資料",
  bundleLoadFailed: "預報資料包載入失敗",
  workerStartFailed: "解碼 Worker 啟動失敗",
  decodeFailed: "解碼失敗",
  frameDecodeFailed: "影格解碼失敗:{message}",
  legendAria: "{label}色階",
  legendInflow: "暖濕氣流",
  legendFront: "鋒區（θe 梯度）",
  legendHotspot: "火點熱點（3.9 µm 上下文判定）",
  legendFfwi: "Fosberg 火險氣象指數",
  legendFwalert: "相對濕度低於 30 % 且陣風 ≥ 10 m/s",
  legendDustDust: "沙塵",
  legendDustThickHigh: "厚高雲",
  legendDustThinHigh: "薄高雲",
  legendDustMid: "中雲",
  legendDustLow: "低暖雲",
  legendDustDesert: "炎熱沙漠地表",
  legendDustSurface: "海面與植被地表",
  legendTruecolorCloud: "雲與雪",
  legendTruecolorSea: "海面",
  legendTruecolorLand: "陸地與植被",
  legendTruecolorNightCloud: "夜間雲（紅外）",
  legendTruecolorNightGround: "夜間晴空",
  legendPtypeRain: "雨",
  legendPtypeFreezingRain: "凍雨",
  legendPtypeSnow: "雪",
  legendPtypeIcePellets: "冰粒",
  legendDisrpBelow: "低於 1.5 年一遇",
  legendDisrp1p5: "≥ 1.5 年一遇",
  legendDisrp2: "≥ 2 年一遇",
  legendDisrp5: "≥ 5 年一遇",
  legendDisrp20: "≥ 20 年一遇",
  legendCatLight: "輕度",
  legendCatModerate: "中度",
  legendCatModerateSevere: "中度–嚴重",
  legendCatSevere: "嚴重",
  varLabelTmp2m: "2 公尺氣溫",
  varLabelPrate: "降水強度",
  varLabelDswrf: "太陽輻射",
  varLabelWind10m: "10 公尺風",
  varLabelWind80m: "80 公尺風",
  varLabelWind100m: "100 公尺風",
  varLabelCref: "雷達組合反射率",
  varLabelRefl3d: "三維雷達回波",
  varLabelCloud3d: "三維雲水",
  varLabelOrog: "地形高度",
  varLabelIr104: "紅外影像（10.4 µm 亮溫）",
  varLabelIr039: "短波紅外（3.9 µm 亮溫）",
  varLabelDustrgb: "沙塵 RGB（紅外合成）",
  varLabelDustcf: "DEBRA 沙塵信心度",
  varLabelZhouye: "ZHOUYE（晝夜）沙塵信心度",
  varLabelTruecolor: "真彩色（白天可見光，夜間紅外雲圖）",
  varLabelGust: "陣風",
  varLabelTcdc: "總雲量",
  varLabelCape: "對流可用位能",
  varLabelCin: "對流抑制",
  varLabelVis: "能見度",
  varLabelDpt2m: "2 米露點",
  varLabelAptmp2m: "2 米體感溫度",
  varLabelLcdc: "低雲量",
  varLabelMcdc: "中雲量",
  varLabelHcdc: "高雲量",
  varLabelPwat: "大氣可降水量",
  varLabelHpbl: "行星邊界層高度",
  varLabelPtype: "降水類型",
  varLabelTmpsfc: "海表溫度（陸地為地表溫度）",
  varLabelIcec: "海冰密集度",
  varLabelIcetk: "海冰厚度",
  varLabelWave: "海浪（有效波高與波向）",
  varLabelHtsgw: "有效波高",
  varLabelPerpw: "主波週期",
  varLabelDirpw: "主波向",
  varLabelWindwave: "風浪（示性波高與波向）",
  varLabelSwell: "湧浪（示性波高與波向，第一分量）",
  varLabelWvhgt: "風浪示性波高",
  varLabelWvper: "風浪平均週期",
  varLabelWvdir: "風浪波向",
  varLabelSwhgt: "湧浪示性波高（第一分量）",
  varLabelSwper: "湧浪平均週期（第一分量）",
  varLabelSwdir: "湧浪波向（第一分量）",
  varLabelAod: "550 nm 氣溶膠光學厚度",
  varLabelAoddust: "沙塵光學厚度",
  varLabelAodsalt: "海鹽光學厚度",
  varLabelAodsulf: "硫酸鹽光學厚度",
  varLabelAodorg: "有機碳光學厚度",
  varLabelAodbc: "黑碳光學厚度",
  varLabelPm25: "地面 PM2.5 濃度",
  varLabelPm10: "地面 PM10 濃度",
  varLabelPm10dust: "地面沙塵 PM10 濃度",
  varLabelDustsfc: "地面沙塵濃度",
  varLabelTsoil1: "土壤溫度，第1層",
  varLabelTsoil2: "土壤溫度，第2層",
  varLabelTsoil3: "土壤溫度，第3層",
  varLabelTsoil4: "土壤溫度，第4層",
  varLabelSoilw1: "土壤濕度，第1層",
  varLabelSoilw2: "土壤濕度，第2層",
  varLabelSoilw3: "土壤濕度，第3層",
  varLabelSoilw4: "土壤濕度，第4層",
  varLabelPrmsl: "海平面氣壓",
  varLabelHeightAtLevel: "{level} 百帕位勢高度",
  varLabelTempAtLevel: "{level} 百帕氣溫",
  varLabelRhAtLevel: "{level} 百帕相對濕度",
  varLabelSpfhAtLevel: "{level} 百帕比濕",
  varLabelWindAtLevel: "{level} 百帕風",
  varLabelQfluxAtLevel: "{level} 百帕水氣通量",
  varLabelVvelAtLevel: "{level} 百帕垂直速度",
  varLabelThetaeAtLevel: "{level} 百帕假相當位溫",
  varLabelCatAtLevel: "{level} 百帕晴空亂流（EDR）",
  legendSubtropicalHigh: "588 線",
  webglUnavailable: "此瀏覽器未提供 WebGL2 環境",
  pointerRequestFailed: "即時指標請求傳回 HTTP {status}",
  manifestRequestFailed: "清單請求傳回 HTTP {status}",
  bundleRequestFailed: "資料包請求傳回 HTTP {status}",
  bundleTooLong: "資料包超出清單宣告的長度",
  bundleLengthMismatch: "資料包長度與清單不一致",
  bundleChecksumMismatch: "資料包檢查碼不一致",
  bundleRunMismatch: "資料包執行週期與清單不一致",
  bundleMissingVariable: "資料包缺少變數 {id}",
  manifestMissingBundle: "清單缺少變數 {id} 的資料包",
  mosaicNoMembers: "拼圖中沒有任何衛星資料可用",

  probeAria: "點位資料序列",
  probeHint: "播放或拖曳時間軸補全序列",
  probeComplete: "序列已完整",
  probeOutside: "該點在本資料集網格之外",
  probeNoData: "此影格無資料",
  probeAwaiting: "等待該影格解碼",
  probeModelElevationLabel: "模式",
  probeDemLabel: "DEM",
  probeCloseAria: "關閉點位資料",
  cardCloseAria: "關閉卡片",

  centerHigh: "高",
  centerLow: "低",

  showcaseLink: "歷史個案",
  showcaseBack: "← 全部個案",
  showcaseHome: "即時預報",
  showcaseTitle: "歷史個案",
  showcaseHeading: "天氣過程回放",
  showcaseArchive: "典藏",
  showcaseIntro: "每個個案都是一段歷史天氣的切片——歷史預報,或實況觀測:同一套編碼管線,裁切到事件所在的區域與時段。",
  showcaseMetaDescription: "歷史天氣過程回放:颱風、豪雨、熱浪等個案的裁切資料集,預報與雷達實況",
  showcaseLoading: "正在讀取個案目錄",
  showcaseEmpty: "尚無歷史個案",
  showcaseLoadFailed: "個案目錄載入失敗:{message}",
  showcaseCaseMissing: "找不到歷史個案 {id}",
  showcaseEventLabel: "過程時間",
  showcaseRunLabel: "起報",
  showcaseSeriesLabel: "起點",
  showcaseRangeLabel: "時效",
  showcaseSpanLabel: "時長",
  showcaseRegionLabel: "區域",
  showcaseGridLabel: "網格",
  showcaseSizeLabel: "資料量",
  showcaseVariablesLabel: "變數",
  showcaseHours: "{count} 小時",
  showcaseCaseAria: "開啟個案 {title}",
  showcaseListAria: "歷史個案列表",

  tcTileTip: "熱帶氣旋",
  varTc: "路徑",
  glyphTc: "颱",
  tcSheetAria: "熱帶氣旋",
  tcHeading: "熱帶氣旋",
  tcAllSystems: "全部編號系統",
  tcNone: "目前沒有活動系統",
  tcUnnamed: "未命名系統",
  tcDisturbances: "擾動與熱帶低壓",
  tcPotential: "潛在系統",
  tcPotentialShow: "顯示 {count} 個僅模式系統",
  tcModelOnly: "僅模式",
  tcAgencies: "官方預報",
  tcModels: "模式路徑",
  tcMembers: "系集成員",
  tcBest: "最佳路徑",
  tcOptionsAria: "颱風選項",
  tcHistoryHeading: "歷史熱帶氣旋",
  tcHistoryIntro: "存檔裡的每一個編號風暴：各機構的最佳路徑、為它做過的每一次預報，以及每次偏了多遠。",
  tcHistorySeasonsAria: "季節",
  tcHistoryBasinsAria: "海域",
  tcHistoryAll: "全部",
  tcHistoryEmpty: "這個季節和海域沒有帶預報的風暴",
  tcHistoryStormAria: "開啟 {name}",
  tcHistorySouthernNote: "南半球的颱風季跨年，從 7 月到次年 6 月，按結束的年份命名：{season} 季即 {from} 至 {to}。",
  tcPageTitle: "歷史熱帶氣旋",
  tcPageMetaDescription: "一個歷史熱帶氣旋：各機構的最佳路徑、存檔中為它做過的每一次預報，以及每次偏了多遠。",
  tcPageLoading: "正在載入風暴",
  tcPageMissing: "存檔裡沒有名為 {id} 的風暴",
  tcPageFailed: "風暴載入失敗：{message}",
  tcPageIssue: "時刻",
  tcPageNoForecast: "此時沒有預報",
  tcPagePrev: "上一個起報時次",
  tcPageNext: "下一個起報時次",
  tcPageSources: "顯示的路徑",
  tcPageErrorsHeading: "路徑誤差（公里）",
  tcPageTruth: "對照的最佳路徑",
  tcPageSource: "來源",
  tcPageErrorsMean: "整個風暴的平均",
  tcPageErrorsThis: "地圖上這次預報",
  tcPageErrorsNone: "這個風暴還沒有預報對照過這條最佳路徑",
  tcPageNote: "誤差是天氣圖時次上到最佳路徑的距離，只計系統處於熱帶或副熱帶氣旋階段的時次；系集按系集平均計。官方預報與同一時次起報的模式並列比較，而這些模式是在官方預報發布之後才跑完的。",
  tcPageId: "ATCF 編號",
  tcPageLife: "生命史",
  tcPagePeak: "最大風速",
  tcPageForecasts: "預報數",
  tcCardSeasons: "季節",
  tcCardStorms: "風暴",
  tcPageDetails: "風暴詳情頁",
  tcPageSeasonList: "本季全部風暴",
  tcCardBrowse: "按季節瀏覽",
  tcPageRadii: "暴風圈",
  tcLegendIntensity: "強度：美國最佳路徑，1 分鐘平均風",

  soundingTileTip: "無線電探空",
  varSounding: "高空",
  glyphSounding: "探",
  airportTileTip: "機場觀測",
  varAirport: "METAR",
  glyphAirport: "機",
  synopTileTip: "地面氣象站",
  varSynop: "地面",
  glyphSynop: "站",
  radarTileTip: "單站雷達",
  varRadarSite: "單站",
  glyphRadarSite: "雷",
  radarProductAria: "雷達產品",
  radarLatest: "最新",
  radarCloseAria: "返回拼圖",
  radarReflectivity: "反射率",
  radarVelocity: "徑向速度",
  stationSounding: "探空",
  stationAirport: "機場",
  stationObserved: "觀測",
  stationFreezingLevel: "零度層高度",
  stationPw: "可降水量",
  stationCategory: "飛行類別",
  stationVisibility: "能見度",
  stationQnh: "QNH",
  stationLevels: "層數",
  stationSynop: "氣象站",
  stationHumidity: "相對濕度",
  stationPrecipitation: "降水量",
  stationPressure: "測站氣壓",
  stationSeaLevelPressure: "海平面氣壓",
  stationSunshine: "日照",
  stationSnowDepth: "積雪深度",
  stationElevation: "海拔",
  stationOpenSounding: "查看探空",
  stationPinHere: "釘在此處",
  fireTileTip: "火點（NASA FIRMS，近 24 小時）",
  varFire: "火點",
  glyphFire: "火",
  fireDetection: "火點",
  fireAcquired: "觀測時間",
  fireRadiativePower: "火輻射功率",
  fireBrightness: "亮溫",
  fireConfidence: "可信度",
  fireConfidenceLow: "低",
  fireConfidenceNominal: "中",
  fireConfidenceHigh: "高",
  fireOverpass: "過境",
  fireDay: "白天",
  fireNight: "夜間",
  aqTileTip: "空氣品質測站（PM2.5）",
  varAq: "PM2.5",
  glyphAq: "氣",
  aqStation: "空氣品質",
  aqAgency: "營運機構",
  aqNetwork: "網絡",
  aqPreliminary: "初步數據：未經審核，可能修改",
  aqDayRange: "PM2.5，近 24 小時",
  aqNearest: "最近的空氣品質測站，{km} km",
  alertsTileTip: "目前生效的天氣警告",
  varAlerts: "警告",
  glyphAlerts: "警",
  alertsCardTitle: "警告",
  alertsInForceNow: "目前生效",
  alertsAsOf: "截至 {time}",
  alertsLevel: "第 {level} 級",
  alertsUntilCancelled: "直至解除",
  alertsIssued: "{time} 發布",
  alertCategoryRain: "大雨",
  alertCategoryFlood: "洪水",
  alertCategoryLandslide: "山泥傾瀉",
  alertCategoryWind: "強風",
  alertCategoryThunderstorm: "雷暴",
  alertCategorySnowIce: "冰雪",
  alertCategoryHeat: "酷熱",
  alertCategoryCold: "寒冷",
  alertCategoryFog: "霧",
  alertCategoryDust: "沙塵",
  alertCategoryFire: "火災危險",
  alertCategoryAir: "空氣品質",
  alertCategoryCoastal: "沿岸",
  alertCategoryMarine: "海上",
  alertCategoryTsunami: "海嘯",
  alertCategoryOther: "其他",
  markerPlace: "地點",
  markerEvent: "事件",
  markerSources: "來源",
  caseMarkersAria: "本個案的地點和事件",
  casePartsAria: "本事件的各段",
  riverHeading: "河川流量",
  riverTracksAria: "水文模式執行",
  riverTrackAnalysis: "分析",
  riverTrackForecast: "預報 {cycle}",
  riverKeyAria: "流量與常態流量之比",
  riverRatio2: "低於常態 2 倍",
  riverRatio10: "2–10×",
  riverRatio100: "10–100×",
  riverRatioMax: "≥ 100×",
  riverKeyField: "按流量著色，色標與圖層圖例相同",
  riverExtents: "淹水範圍",
  riverGaugeHint: "圓圈是水文站：點擊查看流量歷線。",
  riverObserved: "實測",
  riverModelled: "模式",
  riverPeaks: "報告的洪峰",
  riverGaugeLoading: "載入中…",
  riverGaugeUnavailable: "無法取得",

  soundingObserved: "實測",
  soundingModel: "模式",
  soundingNoModel: "12 小時內無模式資料",
  soundingLoading: "正在讀取探空…",
  soundingUnavailable: "探空無法取得",
  soundingExpand: "完整圖表",
  soundingClose: "關閉",
  soundingSheetHeading: "探空曲線",
  soundingSheetAria: "探空曲線圖",

  // The comparison page (compare.html).
  compareLink: "比較",
  compareTitle: "預報比較",
  compareHeading: "模式比較",
  compareEyebrow: "單點",
  compareIntro:
    "同一地點、同一時間軸上的全部即時預報模式：各家起報對未來數小時至數日的預報，並列於最近機場的實況報文之旁。",
  compareMetaDescription:
    "逐小時比較 GFS、ECMWF、AIFS、IFS HRES 與 HRRR 在同一地點的預報，並與最近機場的 METAR 報文對照。",
  compareLatitude: "緯度",
  compareLongitude: "經度",
  compareLocate: "使用我的位置",
  compareLocateFailed: "無法取得位置",
  compareOnMap: "在地圖上檢視",
  compareSpan5: "5 天",
  compareSpan15: "15 天",
  compareFieldsAria: "比較的變數",
  compareModelsAria: "模式比較區塊",
  compareLoading: "正在讀取 {model}…",
  compareModelFailed: "{model}：{message}",
  compareOffGrid: "在該模式網格之外",
  compareNoModels: "沒有模式涵蓋該點",
  compareHide: "隱藏",
  compareShow: "顯示",
  comparePin: "置頂",
  compareHidden: "已隱藏的模式",
  compareRun: "起報",
  compareObservationsFrom: "{icao} 的報文",
  compareNoAirport: "40 公里內無機場",
  compareHours: "時刻",
  compareNow: "現在",
  compareCells: "每個數值取自該模式自身網格中距該點最近的格點，不做內插；時間依你所在時區顯示。",
  metricsMetaDescription: "Xue 每個預報批次何時上線的實測紀錄，來自發布工作流程：相對起報時刻的延遲、缺漏的批次，以及 ERCOT 日前市場截止時已上線的批次。",
  metricsHeading: "批次到達",
  metricsEyebrow: "實測",
  metricsIntro: "每個預報批次在本站上線的時間，取自發布工作流程自身的紀錄：寫入即時指標的時刻，以及它距模式起報時刻多久。",
  metricsNotSla: "以下為實測資料，並非服務承諾：Xue 不對可用性作任何保證。",
  metricsGenerated: "產生於 {time}，最近 {days} 天",
  metricsLoading: "正在讀取統計…",
  metricsEmpty: "尚無統計。統計每六小時由發布工作流程產生一次，請於下次產生後再來查看。",
  metricsFailed: "統計讀取失敗:{message}",
  metricsSourcesHeading: "依資料來源",
  metricsLatencyNote: "延遲從起報時刻算到批次上線的時刻，因此包含模式自身的產製時間。所有時間皆為 UTC。",
  metricsTimelineNote: "每條圖帶涵蓋整個統計窗口：每個已上線的批次一根直條，位置為起報時刻，高度為延遲（以該資料來源自身的最長延遲為滿格）；基線下方的標記表示從未到達的批次。",
  metricsTypicalNote: "* 上游典型可用時間：經驗值，表示模式自身資料通常在起報後多久齊全，並非實測。沒有經驗值的留空。",
  metricsTimelineAria: "{model} 在統計窗口內的到達情形",
  metricsCadence: "每 {hours} 小時",
  metricsLatest: "最新批次",
  metricsLanded: "上線時間",
  metricsLatency: "延遲",
  metricsMedian: "中位數",
  metricsMax: "最大",
  metricsTypical: "上游典型",
  metricsCycles: "已到達批次",
  metricsMissing: "缺漏",
  metricsMissingList: "缺漏的批次",
  metricsRuns: "工作流程執行",
  metricsOutcomeLanded: "已上線",
  metricsOutcomeSkipped: "已略過",
  metricsOutcomeDryRun: "演練",
  metricsOutcomeFailed: "失敗",
  metricsBacklog: "還有 {count} 次工作流程執行未讀取，下次產生時補讀。",
  metricsDeadlinesHeading: "截止時刻",
  metricsDeadlineIntro: "每個當地日期，截止時刻已上線的最新批次，以及當時距其起報時刻的時長。",
  metricsSource: "資料來源",
  metricsCommonest: "通常",
  metricsNoneLive: "無",
  glyphAurora: "A",
  varAurora: "機率",
  varDis06: "流量",
  varDisrp: "重現期",
  varUpstream: "集水",
  fieldGroupSpace: "太空天氣",
  fieldGroupFire: "火險",
  modelGroupForecast: "模式預報",
  modelGroupRadar: "雷達",
  varLabelAurora: "極光可見機率",
  varLabelDis06: "河川流量（6 小時平均）",
  varLabelDisrp: "重現期等級",
  varLabelUpstream: "上游集水面積",
  creditsAurora: "太空天氣：極光可見機率，NOAA SWPC OVATION 模式",
  creditsEfas: "河川流量：Copernicus EMS EFAS v5，歐洲 1′；僅限案例",
  creditsEra5: "再分析：Copernicus C3S ERA5（ECMWF），全球 0.25°，逐時，CC-BY-4.0；僅限案例",
  creditsCams: "氣溶膠分析：Copernicus CAMS（ECMWF），全球 0.4°，每 3 小時，CC-BY-4.0；僅限案例",
};
